import outputs from "../../amplify_outputs.json";

export function getEventApiHttpUrl() {
  return String(outputs?.custom?.events?.url || "").trim();
}
